export const fridayUppercase = "yqa";
export default {fridayUppercase};